import { render, staticRenderFns } from "./urgences.vue?vue&type=template&id=6b813061"
import script from "./urgences.vue?vue&type=script&lang=js"
export * from "./urgences.vue?vue&type=script&lang=js"
import style0 from "./urgences.vue?vue&type=style&index=0&id=6b813061&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports